export const getIsEmbedded = () => window.self !== window.top;
